import { ApiResponse, PaginationQuery } from '@magnetar/admin-api-interfaces'
import { BroadcastDevice } from '@magnetar/data-access'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseBroadcastDevicesParams extends PaginationQuery {
  clinic_id: string | number
  examination_room_id?: string | number
  broadcast_type?: string
  is_active?: boolean
}

export function useBroadcastDevicesByClinicId({
  clinic_id,
  page = 1,
  pageSize = 10,
  sortBy = 'created_at',
  sortOrder = 'desc',
  examination_room_id,
  broadcast_type,
  is_active,
}: UseBroadcastDevicesParams) {
  const { token } = useAuth()

  let url = `/api/clinic/${clinic_id}/broadcast-devices?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`

  if (examination_room_id) {
    url += `&examination_room_id=${examination_room_id}`
  }

  if (broadcast_type) {
    url += `&broadcast_type=${broadcast_type}`
  }

  if (is_active !== undefined) {
    url += `&is_active=${is_active}`
  }

  const { data, error, mutate } = useGet<
    ApiResponse<{
      devices: BroadcastDevice[]
      total: number
      page: number
      pageSize: number
    }>
  >(token ? url : null, undefined, token ?? '')

  return {
    devices: data?.data?.devices ?? [],
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: Math.ceil(data.data.total / data.data.pageSize),
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
